module.exports = __webpack_public_path__ + "static/media/bg_ztk@3x.1168de30.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/subject/bg_ztk@3x.png
// module id = 783
// module chunks = 1